import React, {
  useState, useContext, useRef, useEffect,
} from 'react';
// import { useFetchye } from 'fetchye';
import { useSelector } from 'react-redux';
import uuid from 'react-uuid';
import {
  ButtonPrimary,
  ButtonSecondary,
  DataTableV2,
  DataTableHeadV2,
  DataTableBodyV2,
  DataTableRowV2,
  DataTableHeadCellV2,
  DataTableCellV2,
  Select,
  SelectOption,
  Modal,
  ModalHeader,
  ModalBody,
  IconButton,
} from '@americanexpress/dls-react';
import { IconShow, IconTrash } from '@americanexpress/dls-icons';
import PropTypes from 'prop-types';
import { ChildContext, MemberContext } from '../context';
import {
  encryptPayload,
  getObjectLength, parseHtml, validFileFormat, validFileName,
} from '../../utils/util';
import { responseBuilder } from '../../utils/utilService';
import useManageButtonStates from '../../CustomHooks/useManageButtonState';

const getVal = require('lodash/get');

/**
 * returns DLS input component
 * @param {*} props
 */
/* eslint complexity: ["error", 60] -- need to increase complexity */
const FileUpload = ({
  getFileUploadInfo,
  responseMessage,
  cssProperties,
  fieldValidation,
  loggerApiCall,
  fieldId = 'fileUpload',
  fieldLabel,
  journeyId,
  filledFormData,
  griffinFileInfo,
  setGriffinFileInfo,
  selectFileTypeProps = null,
  formPageType,
  buttonsToDisable = [],
  setDisabledButtons,
  disabledButtons,
  version = 'v1',
  addKeysToPayload = {},
  objectOfFunctions,
}) => {
  const [fileData, setFileData] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);
  const [uploadResponse, setUploadResponse] = useState([]);
  const inputRef = useRef(null);
  const contextVal = useContext(ChildContext);
  const memberDetails = useContext(MemberContext);
  const memberApiUrls = useSelector((state) => state?.getIn(['config', 'memberApiUrls']));
  const date = new Date();
  const [isLoading, setIsLoading] = useState(false);
  const [validationMsg, setValidationMsg] = useState('');
  const inputDls = cssProperties.inputStyle ? cssProperties.inputStyle : 'col-md-5 col-md-offset-1 margin-1-t margin-2-b';
  const uploadButtonDls = cssProperties.uploadButtonStyle ? cssProperties.uploadButtonStyle : 'col-md-4 col-md-offset-1 margin-1-t';
  const tableDls = cssProperties.tableStyle ? cssProperties.tableStyle : 'col-md-10 col-md-offset-1';
  const mandatoryErrorMsg = fieldValidation && fieldValidation.mandatoryErrorMsg ? fieldValidation.mandatoryErrorMsg : 'Please complete this field';
  const fileSizeLimit = fieldValidation && fieldValidation.fileSizeLimit >= 0
    ? fieldValidation.fileSizeLimit : 10;
  const totalFileSizeLimit = fieldValidation && fieldValidation.totalFileSizeLimit >= 0
    ? fieldValidation.totalFileSizeLimit : 30;
  const allowedNumberOfFiles = fieldValidation && fieldValidation.allowedNumberOfFiles
    ? fieldValidation.allowedNumberOfFiles : 5;
  const [uploadedFilesSize, setUploadedFilesSize] = useState(0);
  const [docId, setDocId] = useState('');
  const uploadButtonLabel = fieldLabel && fieldLabel.uploadButtonLabel ? fieldLabel.uploadButtonLabel : 'Upload';
  const tableDocNameHeader = fieldLabel && fieldLabel.tableDocNameHeader ? fieldLabel.tableDocNameHeader : 'Document Name';
  const tableFileTypeHeader = fieldLabel && fieldLabel.tableFileTypeHeader
    ? fieldLabel.tableFileTypeHeader : null;
  const tableDocStatusHeader = fieldLabel && fieldLabel.tableDocStatusHeader ? fieldLabel.tableDocStatusHeader : 'Description of status';
  const tableDocRemoveHeader = fieldLabel && fieldLabel.tableDocRemoveHeader ? fieldLabel.tableDocRemoveHeader : 'To remove';
  const chooseFileButton = fieldLabel && fieldLabel.chooseFileButton ? fieldLabel.chooseFileButton : 'Choose file';
  const hideFileInput = fieldValidation && fieldValidation.hideFileInput
    ? fieldValidation.hideFileInput : false;
  const totalFileUploadText = fieldValidation && fieldValidation.totalFileUploadText
    ? fieldValidation.totalFileUploadText : 'Total files uploaded can be equal or less than';
  const fileSizeLimitError = fieldValidation && fieldValidation.fileSizeLimitError
    ? fieldValidation.fileSizeLimitError : 'File size can not exceed fileSizeLimit MB per file (totalFileSizeLimit MB in total)';
  const fileInputButton = document.querySelector(`#${fieldId}-chooseFileButton`);
  const fileSizeError = fileSizeLimitError.replace('fileSizeLimit', fileSizeLimit).replace('totalFileSizeLimit', totalFileSizeLimit);
  const [disableUploadCTA, setDisableUploadCTA] = useState(false);
  const [disableRemoveCTA, setDisableRemoveCTA] = useState(false);
  const [uploadedFileType, setUploadedFileType] = useState('');
  const [uploadedFileTypeLabel, setUploadedFileTypeLabel] = useState('');
  const [selectFileTypeErrorMsg, setSelectFileTypeErrorMsg] = useState('');

  useManageButtonStates({
    uploadResponse,
    buttonsToDisable,
    disabledButtons,
    fieldId,
    setDisabledButtons,
    minimumRequiredUploads: fieldValidation?.minimumRequiredUploads,
  });

  useEffect(() => {
    const filesForThisTable = [];
    let uploadedFilesSizeForThisTable = 0;
    griffinFileInfo.forEach((fileObj) => {
      if (fileObj.fileFrom === fieldId) {
        uploadedFilesSizeForThisTable += fileObj.size;
        filesForThisTable.push(fileObj);
      }
    });
    setUploadResponse([...filesForThisTable]);
    setUploadedFilesSize(uploadedFilesSizeForThisTable);
  }, [griffinFileInfo]);

  const validationMessages = (type) => {
    switch (type) {
      case 'totalFileLength':
        if (fieldValidation && fieldValidation.numberOfFilesErrorMsg) {
          return fieldValidation.numberOfFilesErrorMsg;
        }
        return `${totalFileUploadText} ${allowedNumberOfFiles}.`;
      case 'fileSizeExceed':
        if (fieldValidation && fieldValidation.fileSizeLimitErrorMsg) {
          return fieldValidation.fileSizeLimitErrorMsg;
        }
        return `${fileSizeError}`;
      case 'totalFileSizeExceed':
        if (fieldValidation && fieldValidation.totalFileSizeExceedErrorMsg) {
          return fieldValidation.totalFileSizeExceedErrorMsg;
        }
        return `${fileSizeError}`;
      case 'fileuploadFailure':
        return fieldValidation?.fileuploadFailureMsg || fieldValidation?.defaultFileUploadFailureMsg || 'File upload unsuccessful, please try again.';
      case 'formatErrorMsg':
        return fieldValidation?.formatErrorMsg || 'Invalid file format!';
      case 'specialCharErrorMsg':
        return fieldValidation?.specialCharErrorMsg || 'File name should not contain special characters.';
      default:
        return null;
    }
  };
  const convertFileSizeToMB = (fileSizeBytes) => {
    const fileSizeMB = fileSizeBytes / (1024 ** 2);
    return fileSizeMB;
  };

  /* eslint-disable max-len -- need */
  const validateFile = (data = null) => {
    if (data || (inputRef && inputRef.current && inputRef.current.files && inputRef.current.files.length > 0)) {
      const file = data || inputRef.current.files[0];
      setFileData('');
      const fileName = file.name;
      const fileSize = file.size;
      const calculatedFileSize = convertFileSizeToMB(uploadedFilesSize)
        + convertFileSizeToMB(fileSize);

      if (!(uploadResponse.length >= allowedNumberOfFiles)) {
        // pass the file name through validation method
        if (!validFileFormat(fileName, fieldValidation?.allowedFormats)) {
          setValidationMsg(validationMessages('formatErrorMsg'));
        } else if (!validFileName(fileName, fieldValidation?.validFileNameRegex)) {
          setValidationMsg(validationMessages('specialCharErrorMsg'));
        } else if (convertFileSizeToMB(fileSize) > fileSizeLimit) {
          setValidationMsg(validationMessages('fileSizeExceed'));
        } else if (calculatedFileSize > totalFileSizeLimit) {
          if (fieldValidation && fieldValidation.totalFileSizeExceedErrorMsg) {
            setValidationMsg(validationMessages('totalFileSizeExceed'));
          } else {
            setValidationMsg(validationMessages('fileSizeExceed'));
          }
        } else {
          setFileData(file);
          setValidationMsg(validationMessages(''));
        }
      } else {
        setValidationMsg(validationMessages('totalFileLength'));
      }
    } else {
      setValidationMsg('');
    }
  };
  /* eslint-enable max-len -- need */
  const onFileChange = (event) => {
    const file = event.target.files[0];
    if (fileInputButton && file) {
      fileInputButton.innerHTML = `${file.name}`;
    }
    validateFile(file);
  };

  function containsObject(obj, list) {
    const flag = list.some((elem) => elem.fileId === obj.fileId);
    return flag;
  }

  const updateTable = (response, fileObj) => {
    /**
     * From griffin response, identify the file that we just uploaded
     * Add details to the fileObject from this file like --> fileId, documentId
     * Push this new fileObject to griffinFileInfo
     * Don't touch fileNames and getFileUploadInfo :)
     */

    const { documentId } = response;
    const uploadedFiles = [...griffinFileInfo];
    const fileNames = [];
    // const { fileId, name } = response.fileList[0];
    setFileData('');
    setDocId(documentId);
    if (response && response.fileList.length > 0) {
      response.fileList.forEach((file) => {
        if ((uploadedFiles.length === 0) || !containsObject(file, uploadedFiles)) {
          fileObj.documentId = documentId;
          fileObj.fileId = file.fileId;
          uploadedFiles.push(fileObj);
        }
        fileNames.push(file.name);
      });
      getFileUploadInfo(fileNames);
      // setUploadResponse([...uploadedFiles]);
      setGriffinFileInfo(uploadedFiles);
    }
  };

  const onFileUpload = async () => {
    const fileObj = {
      statusCode: 200,
      fileData,
      name: fileData.name,
      fileFrom: fieldId,
      type: fileData.type,
      size: fileData.size,
      fileSizeMb: convertFileSizeToMB(fileData.size),
    };

    if (selectFileTypeProps && !uploadedFileType) {
      setSelectFileTypeErrorMsg(selectFileTypeProps.noFileSelectedMsg);
      const fileTypeDropdown = document.querySelector(`#fileSelect-${fieldId}`);
      fileTypeDropdown.focus();
      return;
    }
    setDisableUploadCTA(true);
    let logString = 'event=fileUploadButtonClick status=calledFileUploadApi';
    loggerApiCall(logString, 'info');
    setIsLoading(true);
    setValidationMsg('');
    const formData = new FormData();
    const payload = {
      head: {
        traceId: uuid(),
        span: 'iForm6513',
        journeyId,
      },
      body: {
        originalDocDate: date.toLocaleDateString(),
        documentId: '',
      },
    };
    /**
     * We can add custom keys in payload from objectOfFunctions which has formData,meberInfo, etc.
     */
    if (getObjectLength(addKeysToPayload) > 0) {
      /**
       * create specific payload
       */
      Object.keys(addKeysToPayload).forEach((key) => {
        const dataValue = getVal(objectOfFunctions, addKeysToPayload[key]);
        if (dataValue) {
          payload.body[key] = dataValue;
          fileObj[key] = dataValue;
        }
      });
    } else {
      /**
       * Use default payload
       */
      const defaultPayLoadFields = {
        firstName: memberDetails
          && memberDetails[0].holder
          && memberDetails[0].holder.profile
          && memberDetails[0].holder.profile.firstName ? memberDetails[0].holder.profile.firstName : '',
        lastName: memberDetails
          && memberDetails[0].holder
          && memberDetails[0].holder.profile
          && memberDetails[0].holder.profile.lastName ? memberDetails[0].holder.profile.lastName : '',
        accountToken: memberDetails && memberDetails[0].accountToken,
        caseNumber: filledFormData.caseNumber,
        cardNumber: filledFormData.cardNumber,
      };
      payload.body = { ...payload.body, ...defaultPayLoadFields };
    }

    if (version === 'v1') {
      /**
       * Only in V1 all the files from this table will be added under same documentId
       * Otherwise we create a separate documentId for each file
       */
      payload.body.documentId = docId || '';
    }

    if (selectFileTypeProps && uploadedFileType) {
      payload.body.fileType = uploadedFileType;
      fileObj.fileType = uploadedFileType;
      fileObj.fileTypeLabel = uploadedFileTypeLabel;
      setUploadedFileType('');
      setUploadedFileTypeLabel('');
      setSelectFileTypeErrorMsg('');
    }
    formData.append('file', fileData);
    formData.append('data', encryptPayload(payload));

    const result = await responseBuilder(`${memberApiUrls}/iForms/${formPageType}/doc/upload?cuid=${contextVal.cuid}`,
      {
        method: 'POST',
        credentials: 'include',
        body: formData,
      });
    if (result.statusIndicator === 'T') {
      setDisableUploadCTA(false);
      logString = 'status=fileUploadApiSuccess';
      loggerApiCall(logString, 'info');
      inputRef.current.value = null;
      inputRef.current.files = null;
      updateTable(result.data, fileObj);
      setIsLoading(false);
      if (fileInputButton) {
        fileInputButton.innerHTML = `${chooseFileButton}`;
      }
    } else {
      setDisableUploadCTA(false);
      setIsLoading(false);
      setValidationMsg(validationMessages('fileuploadFailure'));
      loggerApiCall(`status=fileUploadApiFailed errorMsg=${result.message}`, 'error');
    }
  };

  const removeUploadDoc = async (resp) => {
    /**
     * resp is the fileObject that we have to delete from griffin
     */
    setDisableRemoveCTA(true);
    const removeDocPayload = {
      head: {
        traceId: uuid(),
        span: 'span',
      },
      body: {
        documentId: resp.documentId,
        fileId: resp.fileId,
      },
    };

    fetch(`${memberApiUrls}/iForms/${formPageType}/doc/delete?cuid=${contextVal.cuid}`, {
      method: 'DELETE',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(removeDocPayload),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && data.statusIndicator === 'T') {
          setDisableRemoveCTA(false);
          const updatedGriffinFiles = griffinFileInfo.filter(
            (fileObj) => fileObj.fileId !== resp.fileId);
          setGriffinFileInfo([...updatedGriffinFiles]);
          const fileNames = [];
          updatedGriffinFiles.forEach((file) => {
            fileNames.push(file.name);
          });
          // setUploadResponse(updatedTableData);
          setGriffinFileInfo(updatedGriffinFiles);
          getFileUploadInfo(fileNames);
        }
      });
  };

  useEffect(() => {
    validateFile();
  }, [uploadResponse]);

  const checkforSelectionCondition = (option) => {
    if (option.keytoValidate && option.validteFrom === 'filledFormData') {
      if (filledFormData) {
        const value = getVal(filledFormData, option.keytoValidate);
        if (value !== option.valuetoValidateAgainst) {
          return false;
        }
      }
    }
    return true;
  };

  const isPreviewAvailable = (response) => {
    if (response && response.type) {
      const { type } = response;
      if (type === 'application/pdf' || type === 'image/jpeg' || type === 'image/png' || type === 'text/plain') {
        return true;
      }
    }
    return false;
  };

  const handleFileTypeChange = (e) => {
    if (e.target.value === '') {
      setSelectFileTypeErrorMsg(selectFileTypeProps.noFileSelectedMsg);
    } else {
      setSelectFileTypeErrorMsg('');
    }
    setUploadedFileType(e.target.value);
    setUploadedFileTypeLabel(e.target.options[e.target?.selectedIndex]?.text);
  };

  const handleOnInvalid = () => {
    if (uploadResponse.length < fieldValidation?.minimumRequiredUploads) {
      setValidationMsg(mandatoryErrorMsg);
      document.querySelector(`#${fieldId}-chooseFileButton`).focus();
    }
  };

  /**
   * response is nothing but a fileObject from griffinFileInfo
   */
  const tableRow = (response) => (
    <DataTableRowV2 key={response?.fileId}>
      {
        tableFileTypeHeader
          ? (
            <DataTableCellV2>
              {response ? response.fileTypeLabel : ''}
            </DataTableCellV2>
          ) : ''
      }
      <DataTableCellV2>
        {response ? response.name : ''}
      </DataTableCellV2>
      <DataTableCellV2>
        {
          responseMessage.success
        }
      </DataTableCellV2>
      <DataTableCellV2 align="center">
        {
          // only if filetype is pdf or jpeg or png, text file
          isPreviewAvailable(response) && (
            <IconShow
              title="Preview"
              titleId="preview-id"
              className="dls-deep-blue icon-hover pad-1"
              onClick={() => {
                setFileUrl(URL.createObjectURL(response.fileData));
              }}
            />
          )
        }
        <IconButton
          title="Remove Button"
          id={`${response.fileId}-button`}
          disabled={disableRemoveCTA}
          size="lg"
          onClick={
            (e) => removeUploadDoc(response, e)
          }
        >
          <IconTrash
            title="Remove Icon"
            id={`${response.fileId}-icon`}
            className="dls-red pad-1 icon-hover"
            size="sm"
          />
        </IconButton>
      </DataTableCellV2>
    </DataTableRowV2>
  );

  return (
    <>
      {
        selectFileTypeProps && (
          // add a row
          <div className="col-md-12">
            <div className="row">
              <div className={selectFileTypeProps.cssProperties.style}>
                <label
                  className={selectFileTypeProps.fieldLabel.cssProperties.style}
                  htmlFor={`fileSelect-${fieldId}`}
                >
                  {parseHtml(selectFileTypeProps.fieldLabel.label)}
                </label>
                <Select
                  className="select fluid form-control"
                  id={`fileSelect-${fieldId}`}
                  value={uploadedFileType}
                  onChange={handleFileTypeChange}
                >
                  {
                    selectFileTypeProps.fieldOptions.map((option) => (
                      checkforSelectionCondition(option) === true
                        ? (
                          <SelectOption key={option.value} value={option.value}>
                            {option.label}
                          </SelectOption>
                        )
                        : null
                    ))
                  }
                </Select>
                {
                  selectFileTypeErrorMsg
                  && (
                    <div id="alert-error" className="alert dls-color-warning pad-1-t col-md-12">
                      <span className="icon icon-sm dls-icon-warning-filled pad-1-r" />
                      <span>{selectFileTypeErrorMsg}</span>
                    </div>
                  )
                }
              </div>
            </div>
          </div>
        )
      }
      <div className={inputDls}>
        <p id="helpTxt2" className="helpTxt2 body-1 margin-1-b" />
        <p id="dmr_fileSelectStatus" className="dmr_fileSelectStatus legal-2 dls-color-success" />
        <div
          id="Documents_1-iforms-input-container"
          className="Documents_1-iforms-input-container iforms-input-container"
        >
          <span className="iforms-validation-image" /><span className="iforms-required-field" />
          {fieldValidation && fieldValidation.hideFileInput && (
            <ButtonPrimary
              type="button"
              id={`${fieldId}-chooseFileButton`}
              onClick={() => inputRef.current.click()}
              className="docs_uploadButton btn-primary btn btn-block margin-1-tb"
            >
              {chooseFileButton}
            </ButtonPrimary>
          )}
          <input
            data-testid={`${fieldId}-Documents_1`}
            id={`${fieldId}-Documents_1`}
            className="Documents_1 form-control cursor-wait"
            style={{ padding: '2%', borderColor: '#006fcf', color: '#006fcf' }}
            hidden={hideFileInput}
            type="file"
            required={uploadResponse.length < fieldValidation?.minimumRequiredUploads}
            // name={`${fieldId}-Documents_1`}
            ref={inputRef}
            onChange={onFileChange}
            onInvalid={handleOnInvalid}
          />

          {validationMsg && (
          <div id="alert-error" className="alert dls-color-warning pad-1-t">
            <span id="validation_error" className="validation_error dls-red">{validationMsg}</span>
          </div>
          )}

        </div>
      </div>
      <div className={uploadButtonDls}>
        <div id="docs_uploadButton-container" className="docs_uploadButton-container">
          <ButtonSecondary type="button" id="docs_uploadButton" className="docs_uploadButton btn-secondary btn btn-block margin-1-tb" title={uploadButtonLabel} onClick={onFileUpload} disabled={disableUploadCTA || !fileData} loading={isLoading}>{uploadButtonLabel}</ButtonSecondary>
        </div>
      </div>
      {fieldLabel && fieldLabel.tableInfo1 && <p className="heading-4 col-md-10 dls-deep-blue text-align-center col-md-offset-1 margin-1-t margin-1-b">{parseHtml(fieldLabel.tableInfo1)}</p>}
      {fieldLabel && fieldLabel.tableInfo2 && <p className="label-3 col-md-10 text-align-center col-md-offset-1 margin-1-t margin-1-b">{parseHtml(fieldLabel.tableInfo2)}</p>}
      {fieldLabel && fieldLabel.tableInfo3 && <p className="label-3 col-md-10 text-align-center col-md-offset-1 margin-1-t margin-1-b">{parseHtml(fieldLabel.tableInfo3)}</p>}
      <div className={tableDls}>
        <DataTableV2
          checkable={null}
          sortable={true}
          className="display-block-sm-down scroll-x-sm-down"
        >
          <DataTableHeadV2>
            {tableFileTypeHeader
              ? (
                <DataTableRowV2>
                  <DataTableHeadCellV2>
                    {tableFileTypeHeader}
                  </DataTableHeadCellV2>
                  <DataTableHeadCellV2>
                    {tableDocNameHeader}
                  </DataTableHeadCellV2>
                  <DataTableHeadCellV2>
                    {tableDocStatusHeader}
                  </DataTableHeadCellV2>
                  <DataTableHeadCellV2 align="center">
                    {tableDocRemoveHeader}
                  </DataTableHeadCellV2>
                </DataTableRowV2>
              )
              : (
                <DataTableRowV2>
                  <DataTableHeadCellV2>
                    {tableDocNameHeader}
                  </DataTableHeadCellV2>
                  <DataTableHeadCellV2>
                    {tableDocStatusHeader}
                  </DataTableHeadCellV2>
                  <DataTableHeadCellV2 align="center">
                    {tableDocRemoveHeader}
                  </DataTableHeadCellV2>
                </DataTableRowV2>
              )}
          </DataTableHeadV2>
          <DataTableBodyV2>
            {
              uploadResponse.length > 0 && uploadResponse.map((response) => tableRow(response))
            }
          </DataTableBodyV2>
        </DataTableV2>
      </div>
      {

        fileUrl && (
          <Modal
            id={fieldId}
            aria-labelledby={`${fieldId}-modal-header`}
            aria-describedby={`${fieldId}-modal-body`}
            onClose={() => setFileUrl(null)}
            theme={{ '> div': { maxWidth: '55rem' } }}
          >
            <ModalHeader
              id={`${fieldId}-modal-header`}
              closeButtonLabel={`${fieldId}-modal-closeButton`}
              dismissible={true}
            >
              <h1 id={`${fieldId}-modal-title`} className="heading-3 fluid">{fieldLabel?.docPreviewLabel || ''}</h1>
            </ModalHeader>
            <ModalBody id={`${fieldId}-modal-body`}>
              <div className={tableDls}>
                {
                  <iframe
                    src={fileUrl}
                    // src={fileUrl}
                    title="title"
                    height="500"
                    width="100%"
                    referrerPolicy="no referer"
                    style={{ objectFit: 'contain' }}
                  />
                }
              </div>
            </ModalBody>
          </Modal>
        )

      }
    </>
  );
};

FileUpload.propTypes = {
  cssProperties: PropTypes.objectOf(PropTypes.shape),
  getFileUploadInfo: PropTypes.func,
  responseMessage: PropTypes.objectOf(PropTypes.shape),
  fieldValidation: PropTypes.objectOf(PropTypes.shape),
  fieldId: PropTypes.string,
  griffinFileInfo: PropTypes.arrayOf(PropTypes.shape),
  setGriffinFileInfo: PropTypes.func,
  loggerApiCall: PropTypes.func,
  fieldLabel: PropTypes.objectOf(PropTypes.shape),
  journeyId: PropTypes.string,
  filledFormData: PropTypes.objectOf(PropTypes.shape),
  selectFileTypeProps: PropTypes.objectOf(PropTypes.shape),
  setDisabledButtons: PropTypes.func,
  buttonsToDisable: PropTypes.arrayOf(PropTypes.shape),
  disabledButtons: PropTypes.objectOf(PropTypes.shape),
  formPageType: PropTypes.string,
  version: PropTypes.string,
  addKeysToPayload: PropTypes.objectOf(PropTypes.shape),
  objectOfFunctions: PropTypes.objectOf(PropTypes.shape),
};

export default FileUpload;
